<!-- <img src="assets/img/AB_banner.jpg" alt="Banner image">
<img src="assets/img/AB_banner_Rallyp_Desktop.jpg" alt="Banner Rally"> -->

<div id="banner">
    <div class="owl-carousel owl-theme">
        <ng-container *ngIf="!isMobileView; else mobileView">
            <!-- <div class="item bcg" [ngStyle]="{'background-image': 'url(assets/img/AdmiralBet_Nova-dimenzija-zabave_Carousel_Desktop.jpg)'}"></div> -->
            <!-- <a href="https://www.admiral.hr/app/info/eurobet" target="_parent" rel="noreferrer noopener">
                <div class="item bcg" [ngStyle]="{'background-image': 'url(assets/img/AB_Eurobet-2020_Carousel_Desktop3_D_AB.jpg)'}"></div>
            </a> -->
            <!-- <div class="item bcg" [ngStyle]="{'background-image': 'url(assets/img/AB_banner_Rallyp_Desktop.jpg)'}" (click)="navigateToCompetition()"></div> -->
            <a href="https://www.admiral.hr/app/info/freebet_2x20_fb" target="_parent" rel="noreferrer noopener">
                <div class="item bcg" [ngStyle]="{'background-image': 'url(assets/img/AB_20-free-bet_Web_Desktop.jpg)'}"></div>
            </a>

            <!-- <a href="https://www.admiral.hr/app/info/AdmiralBet_Advent-2021" target="_parent" rel="noreferrer noopener">
                <div class="item bcg" [ngStyle]="{'background-image': 'url(assets/img/AB_Adventski-kalendar_Desktop1.jpg)'}"></div>
            </a> -->

        </ng-container>

        <ng-template #mobileView>
            <!-- <div class="item bcg mobile" [ngStyle]="{'background-image': 'url(assets/img/mobile/AdmiralBet_Nova-dimenzija-zabave_Carousel_Mobile.jpg)'}"></div> -->
            <!-- <a href="https://www.admiral.hr/app/info/eurobet" target="_parent" rel="noreferrer noopener">
                <div class="item bcg mobile" [ngStyle]="{'background-image': 'url(assets/img/mobile/AB_Eurobet-2020_Carousel_Mobile3_D_AB.jpg)'}"></div>
            </a> -->
            <!-- <div class="item bcg mobile" [ngStyle]="{'background-image': 'url(assets/img/mobile/AB_banner_Rallyp.jpg)'}" (click)="navigateToCompetition()" ></div> -->
            <a href="https://www.admiral.hr/app/info/freebet_2x20_fb" target="_parent" rel="noreferrer noopener">
                <div class="item bcg mobile" [ngStyle]="{'background-image': 'url(assets/img/mobile/AB_20-free-bet_Web_Mobile.jpg)'}"></div>
            </a>

            <!-- <a href="https://www.admiral.hr/app/info/AdmiralBet_Advent-2021" target="_parent" rel="noreferrer noopener">
                <div class="item bcg mobile" [ngStyle]="{'background-image': 'url(assets/img/mobile/AB_Adventski-kalendar_Mobile1.jpg)'}"></div>
            </a> -->
        </ng-template>

    </div>
</div>

<!-- <div id="banner" [hidden]="!showBanner">
    <div class="owl-carousel owl-theme">
        <ng-container *ngFor="let promotion of promotionsVM.sortedPromotions">
            <a href="{{promotion.url}}" target="_parent" rel="noreferrer noopener">
                <div class="item bcg" [ngStyle]="{'background-image': 'url(../../../promotions/'+ promotion.src + ')'}">
                </div>
            </a>
        </ng-container>
    </div>
</div> -->
